import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import * as contactData from '../data/contacts.json';
import { Contacts } from '../models/contacts';
import { PreferencesService } from '../services/preferences.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit,OnDestroy {

contacts: any = (contactData as any).default;
currentCountryContact: Contacts;
countryCode: string;
countryExists: boolean;


  preferencesSub: Subscription;

  constructor(private preferences:PreferencesService) { 
    this.preferencesSub = this.preferences.countryCode$.subscribe(country => {
      this.countryCode = country
    });
  }
  ngOnDestroy(): void {
    this.preferencesSub.unsubscribe();
  }

  ngOnInit() {
   

    this.getCountryContactData()
  }

  getCountryContactData() {

    this.countryExists = false;

    var result = this.contacts.filter(x => x.countrycode == 'UK') 
    if (result.length > 0) {
      this.currentCountryContact = result;
      this.countryExists = true;
      console.log(this.currentCountryContact);

    };
   
  }

}
